import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=2691411e&scoped=true&"
import script from "./SidebarItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=2691411e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2691411e",
  null
  
)

export default component.exports